import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-incident-list__content" }
const _hoisted_2 = { class: "as-incident-list__content-data" }
const _hoisted_3 = { class: "as-incident-list__event-time as-d-flex as-align-items-center" }
const _hoisted_4 = { class: "as-incident-list__event-score as-d-flex as-flex-1" }
const _hoisted_5 = { class: "as-incident-list__event-icon as-d-flex justify-content-center as-align-items-center" }
const _hoisted_6 = { class: "as-incident-list__player as-d-flex as-flex-1" }
const _hoisted_7 = { class: "as-incident-list__player-name as-d-flex as-flex-column" }

import { computed } from "vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import { usecommonStore } from "~src/stores/CommonStore";
import SkeletonLoader from "~src/components/SkeletonLoader.vue";

const __default__ = {};

interface IProps {
  isHomePage?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsListSkeleton',
  props: {
    isHomePage: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

const props = __props;

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-incident-list as-d-flex as-flex-column", [
    {
      'as-scrolling as-scrolling__result-popup': !_ctx.isHomePage,
      'as-home-scrollable-content': _ctx.isHomePage,
      'as-incident-list-sm': screenWidth.value < 375,
    },
    `as-parent-incident as-parent-incident-${siteName.value}`,
  ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (index) => {
          return _createElementVNode("div", {
            key: index,
            class: "as-incident-list__event as-d-flex as-align-items-center"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(SkeletonLoader, {
                width: "30px",
                height: "30px",
                line: 1
              })
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["as-incident-list__event-detail as-d-flex as-flex-1", {
              'as-incident-list__event-detail--home': index % 2 === 0,
              'as-incident-list__event-detail--away': index % 2 !== 0,
            }])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(SkeletonLoader, {
                  width: "100px",
                  height: "25px",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SkeletonLoader, {
                  width: "37px",
                  height: "37px",
                  mode: "circle",
                  line: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(SkeletonLoader, {
                    width: "100px",
                    height: "25px",
                    line: 1
                  })
                ])
              ])
            ], 2)
          ])
        }), 64))
      ])
    ])
  ], 2))
}
}

})